module.exports = __webpack_public_path__ + "img/max-cloud-approve.3e254b2f.svg";